<template>
  <div>
    <van-list style="min-height: 700px"
              v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="onLoad"
    >
      <slot name="default">

      </slot>
    </van-list>
  </div>
</template>

<script>
export default {
  name: 'Wp_pull_list',
  props: {
    allParams: { type: Object },
    topParamsPdd: { type: Object, default: null },
    url: { type: String, default: '' },
    requestMethod: { type: String, default: 'GET' },
    pageSize: { type: Number, default: 20 },
    dataType: { type: Number, default: 1 },//1,返回数据中的data直接是数组，2返回数据中的data中的list是数组
    autoLoad: { type: Boolean, default: true },
    useFunction: { type: Boolean, default: false },
  },

  data () {
    return {
      //上拉加载的临时list
      data_list: [],

      //上拉加载状态结束
      loading: false,
      //数据全部加载完成的状态
      finished: false,

      finishedText: '已获取全部数据',

      r_url: '',
      auto_load: true,
    }
  },
  watch: {
    url (newUrl) {
      if (newUrl) {
        this.r_url = newUrl
        this.initStatus()
        this.onLoad()
      }
    }
  },
  created () {

    this.r_url = this.url
    this.auto_load = this.autoLoad

    if (!this.auto_load) {
      // 加载状态结束
      this.loading = false
      // 获取数据结束
      this.finished = true
      this.finishedText = ''
    }
  },

  methods: {

    /**
     * 重新获取数据时，重新初始化各种状态
     */
    initStatus () {
      this.allParams.page = 1
      if (this.topParamsPdd) {
        this.topParamsPdd.page = 0
      }
      this.data_list = []
    },

    endLoading(){
      this.finished = true;
      this.loading = false;
      this.finishedText = "没有搜索到商品~";
    },

    clickToLoad(){
      this.auto_load = true;
      this.onLoad();
    },

    /**
     * 上拉加载
     */
    onLoad () {
      if (!this.auto_load) {
        return
      }
      //没有查询参数，获取全部数据
      if (this.useFunction) {
        this.loading = true
        if (this.topParamsPdd) {
          if (!this.allParams.keyword && this.allParams.optid === -2) {
            this.$emit('getDatas', this.topParamsPdd, datas => {
              this.loadData(datas)
            })
          } else {
            this.$emit('getDatas', this.allParams, datas => {
              this.loadData(datas)
            })
          }
        } else {
          this.$emit('getDatas', this.allParams, datas => {
            this.loadData(datas)
          })
        }

      } else {
        this.getMoreData(this.allParams, datas => {
          this.loadData(datas)
        })
      }
    },

    loadData (datas) {
      this.loading = false
      if (datas) {
        if (datas.length === 1 && this.data_list.length === 1) {
          // this.$log("this.data_list.indexOf(datas[0]) = " + (this.data_list[0].skuId === datas[0].skuId))
          if (datas[0].skuId && this.data_list[0].skuId === datas[0].skuId) {
            //京东
            return
          } else if (datas[0].item_id && this.data_list[0].item_id === datas[0].item_id) {
            //淘宝
            return
          }
        }

        for (let i = 0; i < this.pageSize; i++) {
          if (datas[i]) {
            this.data_list.push(datas[i])
          }
        }
        // this.data_list = datas;
        //传递给父组件
        this.$emit('onLoad', this.data_list)

        if (this.allParams.pageIndex) {
          this.allParams.pageIndex += 1
        }
        if (this.allParams.page) {
          this.allParams.page += 1
        }
        if (this.topParamsPdd) {
          this.topParamsPdd.page += this.topParamsPdd.size
        }
      }
      if (!datas || datas.length < 1) {
        this.finished = true
        this.finishedText = '已获取全部数据~'
        if (this.data_list.length === 0) {
          this.finishedText = '没有搜索到商品,请重试~'
        }
      }
    },

    getMoreData (params, fn) {
      if (this.r_url && this.r_url.length > 1) {
        if (this.requestMethod === 'GET') {
          this.loading = true
          this.$getDatasWithUrlAndParams(this.r_url, params, response => {
            // 加载状态结束
            this.loading = false
            // this.$log(response)
            if (response && response.code === 200) {
              this.returnResponse(response.data, fn)
            }

            // 获取数据结束
            if (!response.data || response.data.length < 1) {
              // 获取数据结束

              this.finished = true
              this.finishedText = '已获取全部数据~'
              if (this.data_list.length === 0) {
                this.finishedText = '没有搜索到商品,请重试~'
              }
            }
          })
        } else if (this.requestMethod === 'POST') {
          this.loading = true
          this.$getDatasWithUrlAndParams_Post(this.r_url, params, response => {
            // 加载状态结束
            this.loading = false
            // this.$log(response)
            if (response && response.code === 200) {
              this.returnResponse(response.data, fn)
            }

            // 获取数据结束
            if (!response.data || response.data.length < 1) {
              // 获取数据结束

              this.finished = true
              this.finishedText = '已获取全部数据~'
              if (this.data_list.length === 0) {
                this.finishedText = '没有搜索到商品,请重试~'
              }
            }
          })
        }
      } else {
        this.loading = false
        this.finished = true
        this.finishedText = ''
      }
    },

    returnResponse (data, fn) {
      if (fn) {
        if (data && data.list) {
          if (data.list.length > 0) {
            fn(data.list)
          } else {
            fn(null)
          }
        } else {
          fn(data)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>